import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';

// Components
import Meta from '../shared/Meta';

import styles from '../../../stylesheets/public/layouts/ErrorPage.module.postcss';

function Error404Page() {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className={styles.ErrorPage}>
      <Meta noindex title='Page Not Found' />

      <div className={styles.ErrorPage_hero}>
        <p className={styles.ErrorPage_code}>404</p>
        <h1 className={styles.ErrorPage_heading}>
          This page drove off without us.
        </h1>
        <p className={styles.ErrorPage_subtitle}>
          Looks like this food {vehicleType} has moved to a new location — or maybe it never existed.
          Either way, we&apos;ve got plenty of delicious options waiting for you.
        </p>
      </div>

      <div className={styles.ErrorPage_actions}>
        <Link className='Button Button--large' to='/'>
          Back to Home
        </Link>
        <Link className='Button Button--large Button--outlined' to='/search'>
          Find Food {vehicle_type}s
        </Link>
      </div>

      <div className={styles.ErrorPage_suggestions}>
        <h2 className={styles.ErrorPage_suggestionsTitle}>Maybe you were looking for...</h2>
        <div className={styles.ErrorPage_grid}>
          <Link to='/search' className={styles.ErrorPage_card}>
            <strong>Find food {vehicleType}s near you</strong>
            <span>Browse today&apos;s schedule and locations</span>
          </Link>
          <Link to='/catering' className={styles.ErrorPage_card}>
            <strong>Book catering for an event</strong>
            <span>Get free quotes from local {vehicleType}s</span>
          </Link>
          <Link to='/services' className={styles.ErrorPage_card}>
            <strong>Food {vehicleType}s at your property</strong>
            <span>Office parks, apartments, and breweries</span>
          </Link>
          <Link to='/support' className={styles.ErrorPage_card}>
            <strong>Contact support</strong>
            <span>We&apos;re here to help</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Error404Page;
